/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	console.log(a);
	console.log(v);

	const workHistoryCheck = () => {
		// 職歴アコーディオン内にエラーがあったときにアコーディオンを開く処理
		if($('.contact-toggle01Wrap').length) {
			const $toggleArea = $('.contact-toggle01Wrap');

			if(location.pathname.indexOf("confirm.html") != -1) {
				//confirmしたときだけ動作
				$toggleArea.each(function(i, elem) {
					if ($(elem).find('.js-company_name').val().length) {
						//会社名に値がある場合はアコーディオンを開く
						$(elem).find('.js-toggle').addClass(a);
						$(elem).find('.js-toggleBlock').css('display','block');
					}else {
						//会社名に値がない場合はアコーディオンを閉じる
						$(elem).find('.js-toggle').removeClass(a);
						$(elem).find('.js-toggleBlock').css('display','none');
					}
				});
			}
		}
	};
	const deleteRadio = () => {
		//ラジオボタンのチェックを削除する
		if($('.js-radio_have_delete').length) {
			const $radioHaveDelete = $('.js-radio_have_delete');
			$radioHaveDelete.each(function(i, elem) {
				$radioHaveDelete.find('.js-radio_delete_btn').on('click', function () {
					$radioHaveDelete.find('input').prop('checked',false);
				})
			});
		}
	};
	const showRequestItem = () => {
		// プルダウンの値によってチェックボックスを変更する。
		if($('.js-select_request_item').length) {
			$('.js-select_request_item').on('change', function() {
				$('.js-request_item').css('display', 'none')
				switch($('.js-select_request_item').val()) {
					case "車載用レンズ":
						$('#automotive_lenses').css('display', 'block')
						break;
					case "医療用レンズ":
						$('#medical_devices').css('display', 'block')
						break;
				}
			})
		}
	};
	const toggleRequestItem = () => {
		// ラジオボタンの値によってチェックボックスを変更する。
		if($("input[name='inquiry_type']").length) {
			$("input[name='inquiry_type']").on('change', function() {
				if($('input[name="inquiry_type"]:checked').val() === "資料請求" || $('input[name="inquiry_type"]:checked').val() === "Document Request"){
					$('.js-request_item-active').css("display","block")
					$('.js-request_item-none_active').css("display","none")
				}else {
					$('.js-request_item-active').css("display","none")
					$('.js-request_item-none_active').css("display","block")
				}
			})
		}
	};
	const getParamList = () => {
		// URLからパラメータを取得
		let list = new Object;
		let pair=decodeURI(location.search).substring(1).split('&');
		for(let i=0;pair[i];i++) {
			let kv = pair[i].split('=');
			list[kv[0]]=kv[1];
		}
		return list
	}
	const getParam = (key) => {
		// キーのパラメータを取得、無い場合はNULL
		const paramList = getParamList()
		if(paramList[key]){
			return paramList[key];
		}else {
			return null;
		}
	}
	const initContactInput = () => {
		if ($('.js-product_category').length) {
			$('.js-product_category').each(function () {
				const id = $(this).find('.js-product_category-title').text();
				if (getParam('product_category1') === id) {
					$(this).css('display','block')
					if($('.js-product_category-select').length) {
						console.log($(this).find('.js-product_category-select').val(getParam('product_category2')));
						$(this).find('.js-product_category-select').val(getParam('product_category2'))
					}
				}
			})
		}
	}
	const initRequestInput = () => {
		if($('.js-select_request_item').length) {
			$('.js-select_request_item').val(getParam('product_category1'))
			$('.js-request_item').css('display', 'none')
			switch($('.js-select_request_item').val()) {
				case "車載用レンズ":
					$('#automotive_lenses').css('display', 'block')
					break;
				case "医療用レンズ":
					$('#medical_devices').css('display', 'block')
					break;
			}
		}
	}
	const initContactTechnology = () => {
		if($("input[name='inquiry_type']").length) {
			$("input[name='inquiry_type']").each(function () {
				if ($(this).val() === getParam('inquiry_type')) {
					$(this).attr("checked", true);
				}
			})

			if($('input[name="inquiry_type"]:checked').val() === "資料請求" || $('input[name="inquiry_type"]:checked').val() === "Document Request"){
				$('.js-request_item-active').css("display","block")
				$('.js-request_item-none_active').css("display","none")
			}else {
				$('.js-request_item-active').css("display","none")
				$('.js-request_item-none_active').css("display","block")
			}
		}
	}
	const initRecruitYear = () => {
		const year = new Date().getFullYear();
		if($('.js-birth_year').length) {
			$('.js-birth_year').each(function () {
				$(this).append('<option value="" disabled="" selected=""></option>');
				const currentYear = year - 120;
				for (let i = 105; i >= 0; i--) {
					$(this).append('<option value="' + (currentYear + i) + '">' + (currentYear + i) + '</option>');
				}
			})
		}
		if($('.js-background').length) {
			$('.js-background').each(function () {
				$(this).append('<option value="" disabled="" selected=""></option>');
				const currentYear = year - 104;
				for (let i = 104; i >= 0; i--) {
					$(this).append('<option value="' + (currentYear + i) + '">' + (currentYear + i) + '</option>');
				}
			})
		}
	}

	workHistoryCheck();
	deleteRadio();
	showRequestItem();
	toggleRequestItem();

	// initContactInput();
	initRequestInput();
	initContactTechnology();
	initRecruitYear();

})(window.jQuery, window.FUNCTIONS);
